import { useNavigate, useParams } from "react-router-dom";
import PageTitle from "../../layouts/PageTitle";
import MenuTree from "./MenuTree/MenuTree";
import "../../../i18n";
import { useTranslation } from "react-i18next";
import "./MenuFormShell.css";

/**
 * Super-admin page for managing a menu's structure as a tree:
 * categories ▸ products, or categories ▸ subcategories ▸ products.
 * Reached from the menu list via the "Manage menu" action.
 */
const ManageMenu = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();

  return (
    <div className="container-fluid menu-form-page menu-form-page--manage px-3 pb-5">
      <PageTitle activeMenu={t("manageMenu")} motherMenu={t("kitchen")} />

      <MenuTree
        menuId={id}
        onEditMenu={() => navigate(`/edit-menu/${id}`)}
        onBackToMenus={() => navigate("/menu")}
      />
    </div>
  );
};

export default ManageMenu;
